export default __webpack_public_path__ + "static/media/three.e2aae266.jpg";